import { render } from "./AdminssionProceduresTab1.vue?vue&type=template&id=1f8ccf2d&scoped=true&ts=true"
import script from "./AdminssionProceduresTab1.vue?vue&type=script&lang=ts"
export * from "./AdminssionProceduresTab1.vue?vue&type=script&lang=ts"

import "./AdminssionProceduresTab1.vue?vue&type=style&index=0&id=1f8ccf2d&lang=css"
import "./AdminssionProceduresTab1.vue?vue&type=style&index=1&id=1f8ccf2d&lang=css"
import "./AdminssionProceduresTab1.vue?vue&type=style&index=2&id=1f8ccf2d&scoped=true&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8ccf2d"]])

export default __exports__